@if (!submitted) {
  <div class="title">{{ content[0].title }}</div>
  <p>{{ content[0].subtitle }}</p>
  <form [formGroup]="form" (ngSubmit)="submitFeedback()">
    <div>
      <textarea [formControlName]="content[0].id" id="ideas" rows="5" i18n-aria-label aria-label="ideas"></textarea>
    </div>
    <div class="email">
      <div>
        <b>{{ content[1].title }}</b
        ><br />
        <i>{{ content[1].subtitle }}</i>
      </div>
      <div class="email-inner">
        <input [formControlName]="'consent'" type="checkbox" id="email" />
        <label for="email">{{ content[1].options?.[0]?.label }}</label>
      </div>
    </div>
    <div class="submit">
      <app-button i18n type="submit" variant="primary" [disabled]="form.invalid">Submit your feedback</app-button>
    </div>
  </form>
} @else {
  <div class="submitted">
    <div class="content">
      <div class="title" i18n>Thank you for your feedback!</div>
      <div i18n>Your feedback has been submitted successfully.</div>
    </div>
    <div class="actions">
      <app-button
        [ngStyle]="{ width: showCloseButton() ? 'initial' : '100%' }"
        (click)="submitted = false"
        variant="basic-primary"
        i18n
        >Submit more feedback</app-button
      >
      @if (showCloseButton()) {
        <app-button i18n (click)="closeModal()" variant="primary">close</app-button>
      }
    </div>
  </div>
}
